import React, { useCallback, useEffect, useRef, useState } from 'react';
import ReactCrop, { Crop } from 'react-image-crop';
import { connect } from 'react-redux';

import * as UserAction from '../../src/actions/User.actions';
import 'react-image-crop/dist/ReactCrop.css';
import '../../src/styles/main.scss';
import closeBtn from '../../src/assets/popup_close.svg';
import Button from './Button';

function CropModal({ upImg, handleEditState, uploadProfileImage, hash }) {
	const imgRef = useRef(null);
	const [hrw, sethrw] = useState('width');

	const previewCanvasRef = useRef(null);
	const [crop, setCrop] = useState<{ unit: any; aspect: any } | Crop>({
		unit: '%',
		[hrw]: 95,
		aspect: 1 / 1,
	});
	const [completedCrop, setCompletedCrop] = useState<any>(null);

	useEffect(() => {
		if (!completedCrop || !previewCanvasRef.current || !imgRef.current) {
			return;
		}

		const image: any = imgRef.current;
		const canvas: any = previewCanvasRef.current;
		const crop: any = completedCrop;

		sethrw(image.width > image.height ? 'width' : 'height');

		const scaleX = image.naturalWidth / image.width;
		const scaleY = image.naturalHeight / image.height;
		const ctx = canvas.getContext('2d');
		const pixelRatio = window.devicePixelRatio;

		canvas.width = crop.width * pixelRatio * scaleX;
		canvas.height = crop.height * pixelRatio * scaleY;

		ctx.setTransform(pixelRatio, 0, 0, pixelRatio, 0, 0);
		ctx.imageSmoothingQuality = 'high';

		ctx.drawImage(
			image,
			crop.x * scaleX,
			crop.y * scaleY,
			crop.width * scaleX,
			crop.height * scaleY,
			0,
			0,
			crop.width * scaleX,
			crop.height * scaleY
		);
	}, [completedCrop]);

	function uplaodImageCanvas(canvas, crop) {
		if (!crop || !canvas) {
			return;
		}

		new Promise((resolve, reject) => {
			canvas.toBlob(blob => {
				if (blob) {
					const formData = new FormData();
					formData.append('name', 'dp');
					formData.append('image', blob, 'filename.jpg');

					resolve(blob);
					uploadProfileImage(
						{ data: formData, hash },
						sus => {
							handleEditState();
							console.log('sus', sus);
						},
						err => {
							console.log(err);
						}
					);
				} else {
					reject(new Error('Canvas is empty'));
				}
			}, 'image/jpeg'); //"image/jpeg");
		});
	}

	const onLoad = useCallback(img => {
		imgRef.current = img;
	}, []);

	return (
		<div className='modal_container' style={{ display: 'flex' }}>
			<div className='popup_wrapper'>
				<div className='popup_title_wrapper'>
					<div className='popup_title'>Crop Image</div>
					<div className='close_popup'>
						<img src={closeBtn} alt='' onClick={() => handleEditState()} />
					</div>
				</div>
				<ReactCrop
					imageStyle={{ width: 'auto', height: '400px', objectFit: 'cover' }}
					src={upImg}
					ruleOfThirds
					circularCrop
					onImageLoaded={onLoad}
					crop={crop}
					onChange={c => setCrop(c)}
					onComplete={c => setCompletedCrop(c)}
				/>
				<div>
					<canvas
						ref={previewCanvasRef}
						// Rounding is important so the canvas width and height matches/is a multiple for sharpness.
						style={{
							width: Math.round(completedCrop?.width ?? 0),
							height: Math.round(completedCrop?.height ?? 0),
							display: 'none',
						}}
					/>
				</div>
				<Button
					active
					labal={'Save'}
					onClickEvent={() =>
						uplaodImageCanvas(previewCanvasRef.current, completedCrop)
					}
				/>
			</div>
		</div>
	);
}

const mapStateToProps = ({ user }) => ({
	hash: user?.profilePicture?.hash,
});

const mapDispatchToProps = {
	uploadProfileImage: UserAction.uploadProfileImage,
};

export default connect(mapStateToProps, mapDispatchToProps)(CropModal);
